<template>
    <div>
        <app-k-v
            titulo="Data Solicitação"
            :md="4"
            :lg="3"
            :xl="2"
            :dado="dadosCadastrais.dataCadastro"
            v-if="mostrarData"
        ></app-k-v>
        <app-k-v titulo="Email" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.email"></app-k-v>
        <app-k-v titulo="Telefone" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.telefone"></app-k-v>
        <h5 class="heading-1 mt-4">
            <span>ENDEREÇO</span>
        </h5>
        <app-k-v titulo="Logradouro" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.logradouro"></app-k-v>
        <app-k-v titulo="Número" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.numero"></app-k-v>
        <app-k-v titulo="Complemento" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.complemento"></app-k-v>
        <app-k-v titulo="Bairro" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.bairro"></app-k-v>
        <app-k-v titulo="Cidade" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.cidade"></app-k-v>
        <app-k-v titulo="UF" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.uf"></app-k-v>
        <app-k-v titulo="CEP" :md="4" :lg="3" :xl="2" :dado="dadosCadastrais.cep"></app-k-v>
    </div>
</template>

<script>
export default {
	props: {
		dadosCadastrais: {
			type: Object,
			default: () => {}
		},

		mostrarData: {
			type: Boolean,
			default: () => true
		}
	},

	data() {
		return {}
	}
}
</script>
